<template>
  <main-template>
    <v-card class="mb-2 pa-2 pb-5">
      <v-card-title class="pb-1">Turma: {{ turma.descricao }}</v-card-title>
      <v-card-title class="pt-0">Disciplina(s)</v-card-title>
      <ul>
        <li v-for="disciplina in disciplinasDaGestao" :key="disciplina.id">
          {{ disciplina.descricao }}
        </li>
      </ul>
    </v-card>
    <!-- Botões das Etapas -->
    <v-col cols="12" class="mb-1 pa-4 menu-etapas">
      <v-btn
        v-for="etapa in etapas"
        :key="etapa.id"
        class="ma-1"
        x-small
        :color="etapaSelecionada?.id === etapa.id ? 'primary' : ''"
        outlined
        @click="etapaSelecionada = etapa"
        :disabled="desabilitarBtnEtapa"
      >
        {{ etapa.descricao }}
      </v-btn>
    </v-col>
    <e-progress-loader
      v-if="!notasCarregadas"
      :total="countDisciplinas"
      :loaded="disciplinasCarregadas"
    />

    <div v-else class="position-relative" :class="{ 'overlay-active': !isEtapaDentroDoPeriodo }">
      <div v-if="!isEtapaDentroDoPeriodo" class="text-center pa-3 overlay-message-above-cards mb-3">
        <v-icon size="48" color="orange" class="mb-2">mdi-calendar-clock</v-icon>
        <h3 class="mb-2 orange--text font-weight-medium">Período de Lançamento Indisponível</h3>

        <p class="mb-3 mx-auto text-body-2 white--text" style="max-width: 450px; line-height: 1.4">
          {{ mensagemBloqueio }}
        </p>

        <v-chip color="orange" text-color="white" small outlined>
          <v-icon left x-small>mdi-eye</v-icon>
          Modo Somente Visualização
        </v-chip>

        <div class="mt-3">
          <v-btn
            v-if="!etapaPendente"
            color="warning"
            small
            class="solicitar-btn"
            @click="modalSolicitarAutorizacao = true"
          >
            <v-icon left small>mdi-send-clock</v-icon>
            Solicitar Autorização
          </v-btn>
          <div v-else class="text-caption orange--text mt-1">
            <v-icon x-small color="orange">mdi-clock-outline</v-icon>
            Solicitação pendente de análise.
            <a
              class="orange--text"
              style="cursor: pointer"
              @click="$router.push({ name: 'autorizacoes' })"
            >
              Acompanhe aqui.
            </a>
          </div>
        </div>
      </div>

      <v-card
        class="mt-2 pa-2"
        v-for="nota in notas"
        :key="nota.id"
        elevation="1"
        :class="{
          'red lighten-4':
            $constants.situacoesMatriculaCondition[
              removerEspaco(nota.situacao ? nota.situacao : '')
            ],
        }"
      >
        <div class="text-subtitle-2 font-weight-bold mb-2">
          {{ nota.aluno }}
        </div>

        <!-- Tabela de Notas -->
        <v-col cols="12" v-if="etapaSelecionada && nota" class="pa-0">
          <v-simple-table class="boletim-table dense-table">
            <thead>
              <tr>
                <th class="text-left">Disciplinas</th>
                <th
                  v-for="sub in etapaSelecionada.subetapas.filter(
                    (sub) => sub.tipo_campo === 'valor'
                  )"
                  :key="sub.id"
                  class="text-left"
                >
                  {{ sub.descricao }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="disciplina in disciplinas" :key="disciplina.id">
                <td>
                  <strong>{{ disciplina.descricao }}</strong>
                </td>
                <td
                  v-for="sub in etapaSelecionada.subetapas.filter(
                    (sub) => sub.tipo_campo === 'valor'
                  )"
                  :key="sub.id"
                >
                  <div class="d-flex align-center">
                    <template
                      v-if="
                        savingStatus[
                          etapaSelecionada.id +
                            '-' +
                            disciplina.id +
                            '-' +
                            sub.id +
                            '-' +
                            nota.matricula_id
                        ]?.saving
                      "
                    >
                      <v-progress-linear
                        indeterminate
                        color="primary"
                        height="20"
                        style="width: 50px; border-radius: 4px"
                      />
                    </template>
                    <template v-else>
                      <v-currency-field
                        class="nota-input"
                        @keydown.tab.prevent
                        locale="en-US"
                        hide-details
                        dense
                        mask="#.##"
                        v-if="
                          podeEditar(disciplina.id) &&
                          isEtapaDentroDoPeriodo &&
                          !$constants.situacoesMatriculaCondition[
                            removerEspaco(nota.situacao ?? '')
                          ] &&
                          !substituidaPelaRecuperacao
                            .filter((rec) => rec.mat == nota.matricula_id)
                            .find((rec) => rec.subs.includes(sub.id))
                        "
                        :value="getNota(nota, etapaSelecionada.id, disciplina.id, sub.id)?.valor"
                        :min="0"
                        :max="10"
                        :decimal-length="1"
                        :allow-negative="false"
                        v-bind="{ outlined: true }"
                        :style="{ minWidth: '40px', maxWidth: '50px', fontSize: '12px' }"
                        @change="
                          (val) =>
                            handleInput(
                              val,
                              disciplina.id,
                              sub.id,
                              nota.matricula_id,
                              turma.id,
                              getNota(nota, etapaSelecionada.id, disciplina.id, sub.id)?.id_nota
                            )
                        "
                      />
                      <template
                        v-else-if="
                          $constants.situacoesMatriculaCondition[removerEspaco(nota.situacao ?? '')]
                        "
                      >
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              v-bind="attrs"
                              v-on="on"
                              class="text-caption red--text d-flex align-center"
                              style="
                                min-width: 40px;
                                max-width: 50px;
                                font-size: 12px;
                                cursor: not-allowed;
                              "
                            >
                              <v-icon x-small color="red" class="mr-1">mdi-lock</v-icon>
                              {{
                                getNota(nota, etapaSelecionada.id, disciplina.id, sub.id)?.valor ??
                                "- - -"
                              }}
                            </div>
                          </template>

                          <span
                            >Aluno com situação "{{ nota.situacao }}" não pode receber nota</span
                          >
                        </v-tooltip>
                      </template>

                      <template
                        v-else-if="
                          substituidaPelaRecuperacao
                            .filter((rec) => rec.mat == nota.matricula_id)
                            .find((rec) => rec.subs.includes(sub.id))
                        "
                      >
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              v-bind="attrs"
                              v-on="on"
                              class="text-caption grey--text d-flex align-center"
                              style="
                                min-width: 40px;
                                max-width: 50px;
                                font-size: 12px;
                                cursor: not-allowed;
                              "
                            >
                              <v-icon x-small color="grey" class="mr-1">mdi-lock</v-icon>
                              {{
                                getNota(nota, etapaSelecionada.id, disciplina.id, sub.id)?.valor ??
                                "- - -"
                              }}
                            </div>
                          </template>

                          <span
                            >Existe
                            {{
                              recOuExame(
                                substituidaPelaRecuperacao
                                  .filter((rec) => rec.mat == nota.matricula_id)
                                  .find((rec) => rec.subs.includes(sub.id))
                              )
                            }}
                            substituindo essa nota, portanto ela nao pode ser editada</span
                          >
                        </v-tooltip>
                      </template>
                      <template v-else>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              v-bind="attrs"
                              v-on="on"
                              class="text-caption grey--text d-flex align-center"
                              style="
                                min-width: 40px;
                                max-width: 50px;
                                font-size: 12px;
                                cursor: not-allowed;
                              "
                            >
                              <v-icon x-small color="grey" class="mr-1">mdi-lock</v-icon>
                              {{
                                getNota(nota, etapaSelecionada.id, disciplina.id, sub.id)?.valor ??
                                "- - -"
                              }}
                            </div>
                          </template>
                        </v-tooltip>
                      </template>
                    </template>
                  </div>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
        <v-col cols="12" class="pa-0">
          <v-divider></v-divider>
          <v-simple-table class="boletim-table dense-table">
            <thead>
              <tr>
                <th
                  v-for="sub in etapaSelecionada.subetapas.filter(
                    (sub) => sub.tipo_campo !== 'valor'
                  )"
                  :key="sub.id"
                  class="text-left"
                >
                  {{ sub.descricao }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  v-for="sub in etapaSelecionada.subetapas.filter(
                    (sub) => sub.tipo_campo !== 'valor'
                  )"
                  :key="sub.id"
                >
                  <v-currency-field
                    class="nota-input"
                    v-if="sub.tipo_campo === 'campo_digitavel_global_sem_regra'"
                    locale="en-US"
                    hide-details
                    mask="#.##"
                    dense
                    outlined
                    :disabled="
                      verificarCondicao(sub, nota.matricula_id) ||
                      !isEtapaDentroDoPeriodo ||
                      $constants.situacoesMatriculaCondition[removerEspaco(nota.situacao ?? '')] ||
                      camposDesabilitados[nota.matricula_id] ||
                      camposDesabilitados[
                        nota.notas
                          ?.find((n) => n.etapa_id === etapaSelecionada.id)
                          ?.subetapas?.find((s) => s.sub_etapa_id === 106)?.id_nota
                      ] === true
                        ? true
                        : false
                    "
                    :value="
                      nota.notas
                        ?.find((n) => n.etapa_id === etapaSelecionada.id)
                        ?.subetapas?.find((s) => s.sub_etapa_id === sub.id)?.valor
                    "
                    :min="0"
                    :max="10"
                    :decimal-length="1"
                    :allow-negative="false"
                    :style="{ minWidth: '40px', maxWidth: '50px', fontSize: '12px' }"
                    @change="
                      substituirNota(
                        $event,
                        sub,
                        nota.notas
                          ?.find((n) => n.etapa_id === etapaSelecionada.id)
                          ?.subetapas?.find((s) => s.sub_etapa_id === sub.id),
                        nota.matricula_id
                      )
                    "
                  />

                  <span
                    class="font-weight-bold"
                    style="font-size: 15px"
                    v-else-if="sub.tipo_campo === 'resultado_final'"
                  >
                    <span>
                      {{
                        nota.notas
                          ?.find((n) => n.etapa_id === etapaSelecionada.id)
                          ?.subetapas?.find((s) => s.sub_etapa_id === sub.id)?.valor_texto
                      }}
                    </span>
                  </span>
                  <span
                    class="font-weight-bold"
                    style="font-size: 15px"
                    v-else-if="sub.descricao === 'Média Anual' || sub.descricao === 'Média Final'"
                  >
                    <span>
                      {{
                        nota.notas
                          ?.find((n) => n.etapa_id === etapaSelecionada.id)
                          ?.subetapas?.find((s) => s.sub_etapa_id === sub.id)?.valor
                      }}
                    </span>
                  </span>
                  <div v-else class="d-flex align-center flex-row">
                    <span class="font-weight-bold" style="font-size: 15px">
                      {{
                        nota.notas
                          ?.find((n) => n.etapa_id === etapaSelecionada.id)
                          ?.subetapas?.find((s) => s.sub_etapa_id === sub.id)?.valor
                      }}
                    </span>
                    <template
                      v-if="
                        sub.tipo_campo !== 'campo_digitavel_global_sem_regra' &&
                        arrayMediasMensais.includes(sub.id)
                      "
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <span
                            v-bind="attrs"
                            v-on="on"
                            class="text-caption grey--text d-flex align-center"
                            :style="{
                              minWidth: '40px',
                              maxWidth: '50px',
                              fontSize: '12px',
                              pointerEvents: 'auto',
                              cursor: $constants.situacoesMatriculaCondition[
                                removerEspaco(nota.situacao || '')
                              ]
                                ? 'not-allowed'
                                : 'pointer',
                              opacity: $constants.situacoesMatriculaCondition[
                                removerEspaco(nota.situacao || '')
                              ]
                                ? 0.5
                                : 1,
                            }"
                          >
                            <v-icon
                              @click="
                                atualizarMedia(nota, etapaSelecionada, sub, nota.matricula_id)
                              "
                              color="success"
                              class="mr-1 ml-3"
                            >
                              mdi-reload
                            </v-icon>
                          </span>
                        </template>
                        <span>Recalcular Média</span>
                      </v-tooltip>
                    </template>
                  </div>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-card>
    </div>

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <e-modal-info
      @closeModal="showModal = false"
      :dadosModal="dadosModal"
      :showModal="showModal"
    ></e-modal-info>

    <scroll-top
      :threshold="300"
      :bottom="86"
      :right="24"
      color="primary"
      icon="mdi-arrow-up-bold"
      small
    />

    <e-modal-solicitar-autorizacao
      v-model="modalSolicitarAutorizacao"
      :etapa-id="etapaSelecionada ? etapaSelecionada.id : null"
      :etapa-descricao="etapaSelecionada ? etapaSelecionada.descricao : ''"
      tipo="nota"
      :instrutor-id="instrutorId"
      @solicitacaoEnviada="aoEnviarSolicitacaoNota"
      @solicitacaoDuplicada="etapaPendente = true"
    />
  </main-template>
</template>

<script>
import _, { forEach, each, includes } from "lodash";
import EModalInfo from "@/components/EModalInfo.vue";
import EProgressLoader from "@/components/EProgressLoader.vue";
import EModalSolicitarAutorizacao from "@/components/Autorizacao/EModalSolicitarAutorizacao.vue";

export default {
  components: { EModalSolicitarAutorizacao },
  computed: {
    countDisciplinas() {
      return this.disciplinas.length * 2; // conforme usado no getNotas()
    },
    isEtapaDentroDoPeriodo() {
      if (!this.etapaSelecionada) return true;
      if (this.autorizadoForaDoPeriodo) return true;

      const hoje = new Date();
      const dataInicial = new Date(this.etapaSelecionada.periodo_inicial);
      const dataFinal = new Date(this.etapaSelecionada.periodo_final);

      hoje.setHours(0, 0, 0, 0);
      dataInicial.setHours(0, 0, 0, 0);
      dataFinal.setHours(23, 59, 59, 999);

      return hoje >= dataInicial && hoje <= dataFinal;
    },
    mensagemBloqueio() {
      if (!this.etapaSelecionada) return "";

      const formatarData = (data) => {
        if (!data) return "";
        const [ano, mes, dia] = data.split("T")[0].split("-");
        return `${dia}/${mes}/${ano}`;
      };

      const dataInicial = formatarData(this.etapaSelecionada.periodo_inicial);
      const dataFinal = formatarData(this.etapaSelecionada.periodo_final);

      return `O período de lançamento da etapa "${this.etapaSelecionada.descricao}" é de ${dataInicial} até ${dataFinal}. Não é possível inserir notas fora deste período.`;
    },
  },
  data() {
    return {
      loading: false,
      camposDesabilitados: {},
      mediaAnual: 105,
      visualizarResultadoFinal: [],
      etapas: [],
      disciplinas: [],
      notas: {},
      etapaSelecionada: null,
      saveQueue: {},
      savingStatus: {},
      turma: {},
      matricula: {},
      notasCarregadas: false,
      disciplinasDaGestao: [],
      instrutorId: null,
      autorizadoForaDoPeriodo: false,
      etapaPendente: false,
      modalSolicitarAutorizacao: false,
      subetapas: [],
      dadosModal: {
        titulo: null,
        mensagem1: null,
        mensagem2: null,
        botao: null,
      },
      showModal: false,

      totalAlunos: 0,
      disciplinasCarregadas: 0,
      notasPreenchidas: [],
      substituidaPelaRecuperacao: [],
      recuperacoes: [
        {
          etapaId: 23,
          idRec: 86,
          arraySubsRec: [81, 83],
        },
        {
          etapaId: 26,
          idRec: 92,
          arraySubsRec: [87, 89],
        },
        {
          etapaId: 29,
          idRec: 98,
          arraySubsRec: [93, 95],
        },
        {
          etapaId: 32,
          idRec: 104,
          arraySubsRec: [99, 101],
        },
        {
          etapaId: 33,
          idRec: 106,
          exameFinal: true,
          arraySubsRec: [81, 83, 87, 89, 93, 95, 99, 101],
        },
      ],
      desabilitarBtnEtapa: false,
      arrayMediasMensais: [82, 84, 88, 90, 94, 96, 100, 102],
      arrayMediasBimestraisFinais: [109, 110, 111, 112],
    };
  },
  watch: {
    disciplinasDaGestao(val) {},
    etapaSelecionada(val) {
      if (!val) return;
      if (val.descricao === "Resultado Final") {
        forEach(this.notas, (nota) => {
          // this.verificarMediasPreenchidas(nota.matricula_id);
        });
      }
      this.verificarAutorizacaoNota(val.id);
    },
  },

  mounted() {
    this.loadData();
  },
  methods: {
    disableExameFinalById(id) {
      this.$set(this.camposDesabilitados, id, true); // Marca o campo como desabilitado para esse id
    },
    atualizarMedia(nota, etapa, sub, matriculaId) {
      const notas = this.notas
        .find((n) => n.matricula_id === matriculaId)
        .notas.find((n) => n.etapa_id === this.etapaSelecionada.id)
        .subetapas.filter((s) => s.sub_etapa_id === parseInt(sub.campofixo_subetapas, 10))
        .map((s) => parseFloat(s.valor))
        .filter((v) => !isNaN(v));

      if (notas.length) {
        const media = notas.reduce((a, b) => a + b, 0) / this.disciplinas.length;
        this.getCampoFixoValue(matriculaId, this.etapaSelecionada.id, sub.id, media);
      }

      this.execRegras(etapa.id, matriculaId);
      this.execRegrasGlobal(etapa.id, matriculaId);
    },
    recOuExame(arraySubsRec) {
      if (arraySubsRec && arraySubsRec.subs.length > 3) {
        return "um EXAME FINAL";
      }
      return "uma RECUPERAÇÃO";
    },
    verificarRecuperacaoLancada({ etapaId, idRec, arraySubsRec }) {
      // pegar todas as notas de recuperacao
      forEach(this.notas, (nota) => {
        let rec = this.notas.find((n) => n.matricula_id === nota.matricula_id);
        if (rec) {
          rec = rec.notas
            .find((n) => n.etapa_id === etapaId)
            ?.subetapas.find((s) => s.sub_etapa_id === idRec);
          if (!rec) return;
          if (rec.valor > 0.0 && nota.matricula_id) {
            const jaExiste = this.substituidaPelaRecuperacao.some(
              (obj) => obj.mat === nota.matricula_id && obj.etapaId === etapaId
            );

            if (!jaExiste) {
              this.substituidaPelaRecuperacao.push({
                mat: nota.matricula_id,
                etapaId,
                subs: arraySubsRec,
              });
            }
          }
        }
      });
    },
    verificarResultadoFinal() {
      // pegar todas as notas de recuperacao
      forEach(this.notas, (nota) => {
        const notasDessaMatricula = this.notas.find((n) => n.matricula_id === nota.matricula_id);
        if (notasDessaMatricula) {
          const mediaAnual = notasDessaMatricula.notas
            .find((n) => n.etapa_id === 33)
            ?.subetapas.find((s) => s.sub_etapa_id === 105);

          const examefinal = notasDessaMatricula.notas
            .find((n) => n.etapa_id === 33)
            ?.subetapas.find((s) => s.sub_etapa_id === 106);

          if (mediaAnual.valor >= 6) {
            this.disableExameFinalById(examefinal.id_nota);
          }
        }
      });
    },
    exibirModal(maximo) {
      this.dadosModal = {
        titulo: `Ops! O valor digitado é muito alto`,
        mensagem1: `Insira um valor igual ou abaixo de ${maximo}.`,
        botao: "Ok",
      };
      this.showModal = true;
    },
    podeEditar(disciplinaId) {
      return !!this.disciplinasDaGestao.find((d) => d.id === disciplinaId);
    },
    verificarCondicao(sub, matriculaId) {
      const exameFinal = this.notas
        .find((n) => n.matricula_id === matriculaId)
        .notas.find((n) => n.etapa_id === sub.etapa_id)
        .subetapas.find((s) => s.sub_etapa_id === 106);
      if (sub.campoglobalsemregra_condicao && sub.id === 106 && !exameFinal.valor > 0.0) {
        switch (sub.campoglobalsemregra_condicao) {
          case "Quando esta subteapa for menor que 6": {
            let subetapas = JSON.parse(sub.campoglobalsemregra_subetapas);
            const encontrouNota = [];
            subetapas = subetapas.map((subId) => {
              return this.subetapas.find((s) => s.id === subId);
            });

            subetapas.forEach((sub) => {
              const nota = this.notas
                .find((n) => n.matricula_id === matriculaId)
                .notas.find((n) => n.etapa_id === sub.etapa_id)
                ?.subetapas.find((s) => s.sub_etapa_id === sub.id);

              if (nota) {
                encontrouNota.push(nota);
              }
            });

            if (encontrouNota.length) {
              if (encontrouNota[0].valor < 6) {
                return false;
              }
              // return true;
            }

            break;
          }

          default:
            return true;
        }
      }
    },
    substituirNota(valor, subAtual, nota, matriculaId) {
      this.desabilitarBtnEtapa = true;
      // Converte para número e valida
      let valorNumerico = parseFloat(valor);

      // se o campo de recuperacao estiver preenchido, os campos de inserir valor devem ser desabilitados
      if (subAtual.tipo_campo === "campo_digitavel_global_sem_regra") {
        const itemIndex = this.substituidaPelaRecuperacao.findIndex(
          (obj) => obj.mat === matriculaId && obj.etapaId === subAtual.etapa_id
        );

        if (valor > 0.0) {
          // Se já existe, remove
          if (itemIndex !== -1) {
            this.substituidaPelaRecuperacao.splice(itemIndex, 1);
          }

          const etapaRecDados = this.recuperacoes.find((rec) => rec.etapaId === subAtual.etapa_id);
          this.verificarRecuperacaoLancada(etapaRecDados);
        } else {
          // Se não precisa remover, apenas limpa o array interno subs (se existir o item)
          const item = this.substituidaPelaRecuperacao[itemIndex];
          if (item) {
            item.subs = [];
          }
        }
      }

      if (valorNumerico > 10) {
        valorNumerico = null;
        this.$set(nota, "valor", null);

        // nesse caso se o campo for nulo o campo da nota que foi substituida deve voltar ao seu cálculo normal
        const subetapasParaSubstituir = JSON.parse(subAtual.campoglobalsemregra_subetapas);

        subetapasParaSubstituir.forEach((subId) => {
          this.execRegras(subId, matriculaId, null, null, true);
        });

        this.exibirModal(10);
      } else {
        if (isNaN(valorNumerico)) {
          valor = null;
        }

        this.saveMedia({
          valor,
          etapaId: subAtual.etapa_id,
          disciplinaId: null,
          subetapaId: subAtual.id,
          matriculaId: nota.matricula_id,
          turmaId: this.turma.id,
          idNota: nota.id_nota,
        });

        this.$set(nota, "valor", valor);

        const subetapasParaSubstituir = JSON.parse(subAtual.campoglobalsemregra_subetapas);

        subetapasParaSubstituir.forEach((subId) => {
          // setar a nota dessa matricula e dessa subId para...
          forEach(this.etapas, (etapa) => {
            const notaSubstituida = this.notas
              .find((n) => n.matricula_id === matriculaId)
              .notas.find((n) => n.etapa_id === etapa.id)
              ?.subetapas.find((s) => s.sub_etapa_id === subId);

            let notaPraComparar = notaSubstituida;

            // bim1
            if (notaSubstituida && notaSubstituida.sub_etapa_id === 109) {
              notaPraComparar = this.notas
                .find((n) => n.matricula_id === matriculaId)
                .notas.find((n) => n.etapa_id === etapa.id)
                ?.subetapas.find((s) => s.sub_etapa_id === 85);
            }
            // bim2
            if (notaSubstituida && notaSubstituida.sub_etapa_id === 110) {
              notaPraComparar = this.notas
                .find((n) => n.matricula_id === matriculaId)
                .notas.find((n) => n.etapa_id === etapa.id)
                ?.subetapas.find((s) => s.sub_etapa_id === 91);
            }
            // bim3
            if (notaSubstituida && notaSubstituida.sub_etapa_id === 111) {
              notaPraComparar = this.notas
                .find((n) => n.matricula_id === matriculaId)
                .notas.find((n) => n.etapa_id === etapa.id)
                ?.subetapas.find((s) => s.sub_etapa_id === 97);
            }
            // bim4
            if (notaSubstituida && notaSubstituida.sub_etapa_id === 112) {
              notaPraComparar = this.notas
                .find((n) => n.matricula_id === matriculaId)
                .notas.find((n) => n.etapa_id === etapa.id)
                ?.subetapas.find((s) => s.sub_etapa_id === 103);
            }
            // final
            if (notaSubstituida && notaSubstituida.sub_etapa_id === 107) {
              notaPraComparar = this.notas
                .find((n) => n.matricula_id === matriculaId)
                .notas.find((n) => n.etapa_id === etapa.id)
                ?.subetapas.find((s) => s.sub_etapa_id === 105);
            }

            if (valor == null) {
              valor = 0;
            }

            if (notaSubstituida && valor > notaPraComparar.valor) {
              this.$set(notaSubstituida, "valor", valor);
              this.saveMedia({
                valor,
                etapaId: etapa.id,
                disciplinaId: null,
                subetapaId: subId,
                matriculaId: nota.matricula_id,
                turmaId: this.turma.id,
                idNota: notaSubstituida.id_nota,
              });
              this.execRegrasGlobal(notaSubstituida.sub_etapa_id, nota.matricula_id, subAtual);
            } else if (notaSubstituida && valor < notaPraComparar.valor) {
              // nesse caso se o campo for nulo o campo da nota que foi substituida deve voltar ao seu cálculo normal
              const subetapasParaSubstituir = JSON.parse(subAtual.campoglobalsemregra_subetapas);

              this.$set(notaSubstituida, "valor", notaPraComparar.valor);

              const valor = parseFloat(notaPraComparar.valor, 10);

              this.saveMedia({
                valor,
                etapaId: etapa.id,
                disciplinaId: null,
                subetapaId: subId,
                matriculaId: nota.matricula_id,
                turmaId: this.turma.id,
                idNota: notaSubstituida.id_nota,
              });

              this.execRegrasGlobal(notaSubstituida.sub_etapa_id, nota.matricula_id, subAtual);
            }
          });
        });

        this.desabilitarBtnEtapa = false;
      }
    },

    execRegrasGlobal(subSubstituida, matriculaId, campoCiclado) {
      // this.verificarMediasPreenchidas(matriculaId);
      this.etapas.forEach((etapa) => {
        let notasArray = [];
        const notasArrayIds = [];
        const subs = etapa.subetapas.filter((sub) => sub.tipo_campo === "campo_global_com_regra");

        subs.forEach((sub) => {
          const subetapasUsadas = JSON.parse(sub.campoglobalcomregra_subetapas || "[]");

          this.etapas.forEach((etap) => {
            const notasDaMatricula = this.notas.find((n) => n.matricula_id === matriculaId);
            if (!notasDaMatricula) return;

            const notasDaEtapa = notasDaMatricula.notas.find((n) => n.etapa_id === etap.id);

            if (!notasDaEtapa || !Array.isArray(notasDaEtapa.subetapas)) return;

            const valores = notasDaEtapa.subetapas
              .filter((s) => subetapasUsadas.includes(s.sub_etapa_id))
              .map((s) => parseFloat(s.valor))
              .filter((v) => !isNaN(v));
            const ids = notasDaEtapa.subetapas
              .filter((s) => subetapasUsadas.includes(s.sub_etapa_id))
              .map((s) => parseFloat(s.id_nota))
              .filter((v) => !isNaN(v));

            // adiciona os valores diretamente ao array final
            notasArray.push(...valores);
            notasArrayIds.push(...ids);
          });
          if (
            sub.id !== subSubstituida &&
            campoCiclado?.descricao !== "Exame Final" &&
            !this.arrayMediasBimestraisFinais.includes(sub.id)
          ) {
            if (notasArray.length) {
              let media = notasArray.reduce((a, b) => a + b, 0) / notasArray.length;
              if (sub.id === this.mediaAnual) {
                media = notasArray.reduce((a, b) => a + b, 0) / 4;
              }
              // setar valor na nota dessa matricula que tem o campo global com regra
              this.getCampoFixoValue(matriculaId, etapa.id, sub.id, media);
              notasArray = [];
            }
          }

          // verificar se a subetapa atual tem o campo media_final marcado como true, se tiver deve atualizar o valor do campo do tipo resultado final
          if (sub.media_final && this.notas.find((n) => n.matricula_id === matriculaId)) {
            // verificar se a nota do exame final é maior que o valor da media final
            const mediaFinal = this.notas
              .find((n) => n.matricula_id === matriculaId)
              .notas.find((n) => n.etapa_id === etapa.id)
              .subetapas.find((s) => s.sub_etapa_id === sub.id);

            const exameFinal = this.notas
              .find((n) => n.matricula_id === matriculaId)
              .notas.find((n) => n.etapa_id === etapa.id)
              .subetapas.find((s) => s.sub_etapa_id === 106);

            // adicionar o valor da recuperacao na media final
            if (parseFloat(exameFinal.valor) > parseFloat(mediaFinal.valor)) {
              this.$set(mediaFinal, "valor", exameFinal.valor);
              this.saveMedia({
                valor: exameFinal.valor,
                etapaId: etapa.id,
                disciplinaId: null,
                subetapaId: mediaFinal.sub_etapa_id,
                matriculaId,
                turmaId: this.turma.id,
                idNota: mediaFinal.id_nota,
              });
            }

            // const mediaFinal = notasArray.reduce((a, b) => a + b, 0) / notasArray.length;
            // pegar nota de alguma subetapa dessa matrcula que seja do tipo_campo == 'resultado_final'
            const subetapaId = this.subetapas.find((s) => s.tipo_campo === "resultado_final").id;
            // pegar nota com essa subetapaid dessa matriculaId
            const notaresulFinal = this.notas
              .find((n) => n.matricula_id === matriculaId)
              .notas.find((n) => n.etapa_id === etapa.id)
              .subetapas.find((s) => s.sub_etapa_id === subetapaId);

            this.$set(notaresulFinal, "valor_texto", "- - -");
            if (mediaFinal && mediaFinal.valor >= 6) {
              this.$set(notaresulFinal, "valor_texto", "Aprovado");
              this.saveMedia({
                valor: "Aprovado",
                etapaId: etapa.id,
                disciplinaId: null,
                subetapaId,
                matriculaId,
                turmaId: this.turma.id,
                idNota: notaresulFinal.id_nota,
              });

              const examFinal = this.notas
                .find((n) => n.matricula_id === matriculaId)
                .notas.find((n) => n.etapa_id === etapa.id)
                .subetapas.find((s) => s.sub_etapa_id === 106);

              // this.disableExameFinalById(examFinal.id_nota);

              const notasDessaMatricula = this.notas.find((n) => n.matricula_id === matriculaId);

              const mediaAnual = notasDessaMatricula.notas
                .find((n) => n.etapa_id === 33)
                ?.subetapas.find((s) => s.sub_etapa_id === 105);
              if (mediaAnual.valor >= 6) {
                this.disableExameFinalById(exameFinal.id_nota);
              }
            } else {
              this.$set(notaresulFinal, "valor_texto", "Reprovado");
              this.saveMedia({
                valor: "Reprovado",
                etapaId: etapa.id,
                disciplinaId: null,
                subetapaId,
                matriculaId,
                turmaId: this.turma.id,
                idNota: notaresulFinal.id_nota,
              });
            }
          }
        });
      });
    },
    execRegras(subId, matriculaId, idNota, matId, substituicao = false) {
      // funcao pra verificar se todas as notas foram preenchidas
      // this.verificarNotasPreenchidas(matriculaId, this.etapaSelecionada.id, subId);

      // if (!this.notasPreenchidas[matriculaId]?.subs.includes(subId)) return;

      this.etapaSelecionada.subetapas
        .filter((sub) => sub.tipo_campo === "campo_fixo")
        .forEach((sub) => {
          if (subId === parseInt(sub.campofixo_subetapas, 10)) {
            switch (sub.campofixo_operacao) {
              case "Média Aritmética": {
                // pegar todas as notas dessa matricula nessa subetapa
                const notas = this.notas
                  .find((n) => n.matricula_id === matriculaId)
                  .notas.find((n) => n.etapa_id === this.etapaSelecionada.id)
                  .subetapas.filter((s) => s.sub_etapa_id === parseInt(sub.campofixo_subetapas, 10))
                  .map((s) => parseFloat(s.valor))
                  .filter((v) => !isNaN(v));

                if (notas.length) {
                  const media = notas.reduce((a, b) => a + b, 0) / this.disciplinas.length;
                  this.getCampoFixoValue(matriculaId, this.etapaSelecionada.id, sub.id, media);
                }

                break;
              }

              default:
                break;
            }
          }
        });

      let notasArray = [];

      this.etapas.forEach((etapa) => {
        const subs = etapa.subetapas.filter((sub) => sub.tipo_campo === "campo_global_com_regra");

        subs.forEach((sub) => {
          const subetapasUsadas = JSON.parse(sub.campoglobalcomregra_subetapas || "[]");

          this.etapas.forEach((etap) => {
            const notasDaMatricula = this.notas.find((n) => n.matricula_id === matriculaId);
            if (!notasDaMatricula) return;

            const notasDaEtapa = notasDaMatricula.notas.find((n) => n.etapa_id === etap.id);

            if (!notasDaEtapa || !Array.isArray(notasDaEtapa.subetapas)) return;

            const valores = notasDaEtapa.subetapas
              .filter((s) => subetapasUsadas.includes(s.sub_etapa_id))
              .map((s) => parseFloat(s.valor))
              .filter((v) => !isNaN(v));

            // adiciona os valores diretamente ao array final
            notasArray.push(...valores);
          });

          // se as subetapas forem medias bimestrais finais 1,2,3,4 e se for media final, faz-se uma condicao se
          const subetapasNaoPodemEntrar = this.arrayMediasBimestraisFinais;
          // se a recuperacao for nula ou menor que a media bimestral final
          // 1.pegar a media bimestral final
          if (notasArray.length && subetapasNaoPodemEntrar.includes(sub.id)) {
            // pega o valor da recuperacao dessa etapa pra poder comparar
            const arraysRecuperacao = [86, 92, 98, 104, 107];
            const recuperacao = this.notas
              .find((n) => n.matricula_id === matriculaId)
              .notas.find((n) => n.etapa_id === sub.etapa_id)
              .subetapas.find((s) => arraysRecuperacao.includes(s.sub_etapa_id)).valor;
            const media = notasArray.reduce((a, b) => a + b, 0) / notasArray.length;
            if (recuperacao < media) this.getCampoFixoValue(matriculaId, etapa.id, sub.id, media);
            notasArray = [];
            return;
          }

          if (notasArray.length && substituicao === true) {
            const media = notasArray.reduce((a, b) => a + b, 0) / notasArray.length;
            // setar valor na nota dessa matricula que tem o campo global com regra

            this.getCampoFixoValue(matriculaId, etapa.id, sub.id, media);
            notasArray = [];
          } else if (notasArray.length && !subetapasNaoPodemEntrar.includes(sub.id)) {
            const media = notasArray.reduce((a, b) => a + b, 0) / notasArray.length;
            // setar valor na nota dessa matricula que tem o campo global com regra

            this.getCampoFixoValue(matriculaId, etapa.id, sub.id, media);
            notasArray = [];
          }

          // verificar se a subetapa atual tem o campo media_final marcado como true, se tiver deve atualizar o valor do campo do tipo resultado final
          if (sub.media_final && this.notas.find((n) => n.matricula_id === matriculaId)) {
            // pegar nota de alguma subetapa dessa matrcula que seja do tipo_campo == 'resultado_final'
            const subetapaId = this.subetapas.find((s) => s.tipo_campo === "resultado_final").id;
            // pegar nota com essa subetapaid dessa matriculaId
            const mediaFinal = this.notas
              .find((n) => n.matricula_id === matriculaId)
              .notas.find((n) => n.etapa_id === etapa.id)
              ?.subetapas.find((s) => s.sub_etapa_id === sub.id);

            const notaresulFinal = this.notas
              .find((n) => n.matricula_id === matriculaId)
              .notas.find((n) => n.etapa_id === etapa.id)
              ?.subetapas.find((s) => s.sub_etapa_id === subetapaId);

            if (!mediaFinal || !notaresulFinal) return;

            this.$set(notaresulFinal, "valor_texto", "- - -");
            if (mediaFinal && mediaFinal.valor >= 6) {
              this.$set(notaresulFinal, "valor_texto", "Aprovado");
              this.saveMedia({
                valor: "Aprovado",
                etapaId: etapa.id,
                disciplinaId: null,
                subetapaId,
                matriculaId,
                turmaId: this.turma.id,
                idNota: notaresulFinal.id_nota,
              });
            } else {
              this.$set(notaresulFinal, "valor_texto", "Reprovado");
              this.saveMedia({
                valor: "Reprovado",
                etapaId: etapa.id,
                disciplinaId: null,
                subetapaId,
                matriculaId,
                turmaId: this.turma.id,
                idNota: notaresulFinal.id_nota,
              });
            }
          }
        });
      });
    },
    getNota(nota, etapaId, disciplinaId, subId) {
      const etapa = nota.notas?.find((n) => n.etapa_id === etapaId);
      if (!etapa) return null;

      const sub = etapa.subetapas.find(
        (s) => s.sub_etapa_id === subId && s.disciplina_id === disciplinaId
      );

      return sub;
    },
    async getNotaCreate(nota, etapaId, disciplinaId, subId) {
      await this.getNotasCreate(this.turma.id, disciplinaId);
      const etapa = nota.notas?.find((n) => n.etapa_id === etapaId);
      if (!etapa) return null;

      const sub = etapa.subetapas.find(
        (s) => s.sub_etapa_id === subId && s.disciplina_id === disciplinaId
      );

      return sub;
    },

    getCampoFixoValue(matriculaId, etapaId, subId, valor = 0) {
      const notaMedia = this.notas
        .find((n) => n.matricula_id === matriculaId)
        .notas.find((n) => n.etapa_id === etapaId)
        ?.subetapas.find((s) => s.sub_etapa_id === subId);
      if (!notaMedia) return;
      this.$set(notaMedia, "valor", valor.toFixed(2));
      // salvar essa nota
      this.saveMedia({
        valor: valor.toFixed(2),
        etapaId,
        disciplinaId: null,
        subetapaId: subId,
        matriculaId,
        turmaId: this.turma.id,
        idNota: notaMedia.id_nota,
      });
    },
    async saveMedia({ valor, etapaId, disciplinaId, subetapaId, matriculaId, turmaId, idNota }) {
      this.loading = true;
      try {
        const dado = await this.$services.notasService.saveNotaPolivalencia({
          valor: subetapaId === 108 ? valor : parseFloat(valor, 2),
          etapaId,
          disciplinaId,
          subetapaId,
          matriculaId,
          turmaId,
          idNota,
        });
        // aqui tu pode fazer algo com "dado"
      } catch (error) {
        this.$handleError(error);
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      }
    },

    handleInput(valor, discId, subId, matriculaId, turmaId, idNota) {
      this.desabilitarBtnEtapa = true;
      const etapaId = this.etapaSelecionada.id;
      const key = `${etapaId}-${discId}-${subId}-${matriculaId}`;
      // if (valor === null) {
      //   valor = 0;
      // }
      // Converte para número e valida
      let valorNumerico = parseFloat(valor);
      if (valorNumerico > 10) {
        this.exibirModal(10);
        valorNumerico = null;
      }
      this.$set(this.savingStatus, key, { saving: true, saved: false });

      if (isNaN(valorNumerico)) {
        valorNumerico = null;
      }

      if (!this.saveQueue[key]) {
        this.saveQueue[key] = _.debounce(this.saveNota, 800);
      }

      this.saveQueue[key]({
        valor: valorNumerico,
        etapaId,
        disciplinaId: discId,
        subetapaId: subId,
        matriculaId,
        turmaId,
        idNota,
      });
    },

    verificarNotasPreenchidas(matriculaId, etapaId, subetapaId) {
      let notas = this.notas
        .find((n) => n.matricula_id === matriculaId)
        .notas.find((n) => n.etapa_id === etapaId)
        .subetapas.filter((s) => s.sub_etapa_id === subetapaId);

      if (this.notas.find((n) => n.matricula_id === matriculaId).isEja) {
        const disciplinasEja = [25, 26, 27, 28, 29, 30, 31, 32];
        // as notas no campo disciplina_id tem que ter essas disciplinas
        notas = this.notas
          .find((n) => n.matricula_id === matriculaId)
          .notas.find((n) => n.etapa_id === etapaId)
          .subetapas.filter(
            (s) => s.sub_etapa_id === subetapaId && disciplinasEja.includes(s.disciplina_id)
          );
      }

      const notasValores = notas.map((n) => {
        return {
          valor: n.valor,
        };
      });

      const temValorEmBranco = notasValores.some(
        (item) => item.valor === "" || item.valor == null || String(item.valor).trim() === ""
      );

      this.notasPreenchidas[matriculaId] = {
        subs: [],
      };

      if (temValorEmBranco === false) {
        this.notasPreenchidas[matriculaId].subs.push(subetapaId);
      } else {
        this.notasPreenchidas[matriculaId].subs.splice(
          this.notasPreenchidas[matriculaId].subs.indexOf(subetapaId),
          1
        );
      }
    },
    async verificarMediasPreenchidas(matriculaId) {
      const verificar = await this.$services.notasService.verificarMediasPreenchidas(matriculaId);
      if (verificar === "preenchidas") {
        this.visualizarResultadoFinal.push(matriculaId);
      }
      // remover itens repetidos do array
    },

    async saveNota({ valor, etapaId, disciplinaId, subetapaId, matriculaId, turmaId, idNota }) {
      const key = `${etapaId}-${disciplinaId}-${subetapaId}-${matriculaId}`;
      try {
        await this.$services.notasService.saveNotaPolivalencia({
          valor,
          etapaId,
          disciplinaId,
          subetapaId,
          matriculaId,
          turmaId,
          idNota,
        });

        const nota = this.notas.find((n) => n.matricula_id === matriculaId);
        const sub = (await idNota)
          ? this.getNota(nota, etapaId, disciplinaId, subetapaId)
          : this.getNotaCreate(nota, etapaId, disciplinaId, subetapaId);
        if (sub) {
          sub.valor = valor; // atualiza localmente com o valor salvo
        }
        this.$set(this.savingStatus, key, { saving: false, saved: true });
        this.$root.$emit("show-snackbar", "Nota salva com sucesso");

        this.execRegras(subetapaId, matriculaId, idNota);
      } catch (error) {
        this.$set(this.savingStatus, key, { saving: false, saved: false });
        this.$handleError(error);
      }

      setTimeout(() => {
        if (this.savingStatus[key]?.saved) {
          this.$set(this.savingStatus, key, { saving: false, saved: false });
          this.desabilitarBtnEtapa = false;
        }
      }, 2000);
    },

    async loadData() {
      this.$loaderService.open("Carregando notas...");
      try {
        const data = await this.$services.notasService.getCircuitoEtapas(
          parseInt(this.$route.params.gestaoDeAulasId, 10)
        );
        this.etapas = data.etapas;
        this.subetapas = data.subetapas;
        this.disciplinas = data.disciplinas;
        this.turma = data.turma;
        this.matricula = data.matricula;

        this.etapas.forEach((etapa) => {
          if (!this.notas[etapa.id]) this.notas[etapa.id] = {};
          this.disciplinas.forEach((disc) => {
            if (!this.notas[etapa.id][disc.id]) this.notas[etapa.id][disc.id] = {};
            etapa.subetapas.forEach((sub) => {
              this.notas[etapa.id][disc.id][sub.id] = "";
            });
          });
        });

        this.etapaSelecionada = this.etapas[0];

        // fazer um foreach de disciplinas dessa turma
        each(this.disciplinas, (disciplina) => {
          this.getNotas(this.turma.id, disciplina.id);
        });

        this.disciplinas.forEach((disciplina) => {
          this.getNotas(this.turma.id, disciplina.id);
        });

        this.disciplinasDaGestao = data.disciplinasDaGestao;
        this.instrutorId = data.gestaoDeAula?.instrutor_id ?? null;

        if (this.etapaSelecionada) {
          this.verificarAutorizacaoNota(this.etapaSelecionada.id);
        }
      } catch (error) {
        this.$handleError(error);
      }
      // this.$loaderService.close();
    },

    async getNotas(turmaId, disciplinaId) {
      try {
        const data = await this.$services.notasService.getNotasPolivalencia(turmaId, disciplinaId);

        if (!this.totalAlunos) {
          this.totalAlunos = data.data.length; // Conta quantos alunos vieram da API
        }

        this.notas = data.data; // ou conforme sua lógica de merge

        this.disciplinasCarregadas += 1;

        if (this.disciplinasCarregadas >= this.countDisciplinas) {
          this.notasCarregadas = true;
        }

        forEach(this.recuperacoes, (etapa) => {
          this.verificarRecuperacaoLancada(etapa);
        });
        this.verificarResultadoFinal();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async getNotasCreate(turmaId, disciplinaId) {
      try {
        const data = await this.$services.notasService.getNotasPolivalencia(turmaId, disciplinaId);
        this.notas = data.data;
      } catch (error) {
        this.$handleError(error);
      }
    },
    removerEspaco(string) {
      return string.replace(" ", "_").replace(" ", "_").replace(" ", "_");
    },

    async verificarAutorizacaoNota(etapaId) {
      if (!etapaId) return;
      try {
        const response = await this.$services.autorizacoesService.verificarPedidosDeferidos(
          etapaId,
          "nota"
        );
        this.autorizadoForaDoPeriodo = response.data.aprovados?.length > 0;
        this.etapaPendente = response.data.pendentes?.length > 0;
      } catch (error) {
        // silencia para não bloquear carregamento de notas
      }
    },

    aoEnviarSolicitacaoNota() {
      this.etapaPendente = true;
    },
  },
};
</script>

<style>
.boletim-table th,
.boletim-table td {
  border: 1px solid #ccc;
  padding: 2px 4px !important;
  font-size: 12px !important;
}

.nota-input {
  width: 50px;
  font-size: 15px !important;
}

.dense-table {
  font-size: 12px;
}

.position-relative {
  position: relative;
  min-height: 400px;
}

.overlay-message-above-cards {
  /* position: relative !important; */
  z-index: 10 !important;
  width: 100% !important;
  background: #424242 !important;
  border-radius: 5px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
}

.overlay-active .v-card,
.overlay-active .v-btn:not(.solicitar-btn),
.overlay-active input,
.overlay-active .v-currency-field {
  pointer-events: none !important;
  user-select: none !important;
}

.menu-etapas {
  position: sticky;
  top: 0;
  z-index: 5;
  background: white;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.08);
  border-bottom: 2px solid #ccc;
}
</style>
